const LOCAL = /^(localhost|127\.0\.0\.1)$/;

export function isLocalHost(hostname) {
  return LOCAL.test(hostname || "");
}

/** Upgrade http:// to https:// except local development. */
export function ensureHttps(url) {
  if (url == null || typeof url !== "string") return url;
  const trimmed = url.trim();
  if (!trimmed) return trimmed;
  if (!/^https?:\/\//i.test(trimmed)) return trimmed;
  try {
    const u = new URL(trimmed);
    if (!isLocalHost(u.hostname) && u.protocol === "http:") u.protocol = "https:";
    return u.toString();
  } catch {
    return trimmed.replace(/^http:\/\//i, "https://");
  }
}

/** Site origin, always https on deployed hosts. */
export function publicOrigin() {
  if (typeof window === "undefined") return "";
  return ensureHttps(window.location.origin).replace(/\/$/, "");
}

export function publicUrl(path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${publicOrigin()}${p}`;
}
